module.exports = __webpack_public_path__ + "img/message.5cc750dc.png";